module.exports = __webpack_public_path__ + "img/wolvering-insurance-logo.929a5490.svg";